import styled, { css } from 'styled-components';
import { parseAlignProp } from "../props/AlignProps.js";
import { parseCollapsedBelow } from "../props/CollapseProp.js";
import { parseResponsiveProp } from "../props/ResponsiveProp.js";
import { parseSpaceProp } from "../props/SpaceProp.js";
function columnsRootMixin(align, horizontalAlign, spaceProp, isReversed, isCollapsed) {
  var space = parseSpaceProp(spaceProp);
  return css(["--column-space-left:", "px;--column-space-top:", "px;--column-space-bottom:", "px;align-items:", ";justify-content:", ";margin-left:", "px;width:", ";flex-direction:", ";"], isCollapsed ? 0 : space, isCollapsed && isReversed ? space : 0, isCollapsed && !isReversed ? space : 0, parseAlignProp(align), parseAlignProp(horizontalAlign), isCollapsed ? 0 : "-".concat(space), isCollapsed ? '100%' : "calc(100% + ".concat(space, "px)"), isCollapsed ? !isReversed ? 'column' : 'column-reverse' : !isReversed ? 'row' : 'row-reverse');
}
export var Columns = /*#__PURE__*/styled.div.withConfig({
  displayName: "Columns",
  componentId: "SD__sc-1a73118-0"
})(_ref => {
  var {
    theme,
    collapseBelow,
    align: alignProp = 'top',
    horizontalAlign: horizontalAlignProp = 'left',
    space: spaceProp = 'none',
    reverse: reverseProp = false
  } = _ref;
  var align = parseResponsiveProp(alignProp);
  var horizontalAlign = parseResponsiveProp(horizontalAlignProp);
  var space = parseResponsiveProp(spaceProp);
  var reverse = parseResponsiveProp(reverseProp);
  var collapsed = parseCollapsedBelow(collapseBelow);
  return css(["width:100%;display:flex;", ";", "{", ";}", "{", ";}"], columnsRootMixin(align[0], horizontalAlign[0], space[0], reverse[0], collapsed[0]), theme.breakpoints.up('sm'), columnsRootMixin(align[1], horizontalAlign[1], space[1], reverse[1], collapsed[1]), theme.breakpoints.up('md'), columnsRootMixin(align[2], horizontalAlign[2], space[2], reverse[2], collapsed[2]));
});